export const Esp = "ESP";
export const ClockStation = "ClockStation";
export const ClockMehanics = 0x4D;
export const ClockMehanicsN = 0x4E;
export const ClockMehanicsV = 0x56;
export const DimmerD = 0x44;
export const DimmerS = 0x53;
export const UPS = 73;
export const ElectronicClock = 69;
export const Sensors = 84;
